import React from "react";
import { H1 } from "notes";

export const UnsupportedBrowser = () => {
  return <H1>Try using Chrome (or Safari on iOS)!</H1>;
};
